import React, { useState } from 'react'
import { Typography, Button, Card } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import BeaconOverviewDialogInteresting from './BeaconOverviewDialogInteresting'
import BeaconOverviewDialogThankYou from './BeaconOverviewDialogThankYou'
import effects from 'app/effects/effects'
import { updateInterestedBeacon } from 'app/store/actions/place.actions'
import MessageAlert from 'app/components/MessageAlert'
import BeaconOverviewParagraph from './BeaconOverviewParagraph'
import { Link } from 'react-router-dom'
import { usePlace } from 'commons/usePlace'
import { useAppName } from 'commons/usePartner'
import { Player, BigPlayButton } from 'video-react'
import 'video-react/dist/video-react.css'
import 'styles/video-react.css'
import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import { useIsPaidPlan } from 'app/auth/paidPlanAccess'
import PaidPlanAccessBlock from 'app/auth/PaidPlanAccessBlock'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.lightGrey,
  },
  appBar: {
    color: theme.palette.primary.contrastText,
  },
  header: {},
  paragraphContainer: {
    marginBottom: 36,
  },
  HelpLink: {
    color: '#0073b1 !important',
    textDecoration: 'none !important',
  },
}))

const Content = () => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const classes = useStyles()
  const place = usePlace()
  const [openInterestingDialog, setOpenInterestingDialog] = useState(false)
  const [openThankYouDialog, setOpenThankYouDialog] = useState(false)
  const onLetMeKnow = () => {
    effects.apis
      .interestBeacon()
      .then(() => {
        dispatch(updateInterestedBeacon(true))
        setOpenInterestingDialog(false)
        setOpenThankYouDialog(true)
      })
      .catch((error) => {
        dispatch(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }
  const onHelpCenter = () => {
    window.open(process.env.REACT_APP_HELP_CENTER_URL, '_blank')
  }
  const isPaidPlan = useIsPaidPlan()
  const appName = useAppName()

  return (
    <div className="flex flex-col z-50 pb-16">
      {!isPaidPlan && (
        <div className="flex flex-col items-center my-24 mx-16">
          <div className="max-w-md">
            <Card>
              <div className="m-16">
                <PaidPlanAccessBlock
                  iconSize="sm"
                  titleId="paidPlanRestriction.beacon.description.text"
                />
              </div>
            </Card>
          </div>
        </div>
      )}
      <div className={clsx(classes.header, 'flex flex-col items-center')}>
        <div
          className={clsx(
            'flex flex-col py-24 px-8 w-full sm:w-3/4 items-center',
          )}
        >
          <Player
            fluid={true}
            className="mb-16 mt-16"
            playsInline
            poster="https://front-assets.s3-us-west-2.amazonaws.com/nm-intro-beacon.png"
            src="https://iyc-landing-media.s3.us-west-2.amazonaws.com/new_beacon_intro.mp4"
          >
            <BigPlayButton position="center" />
          </Player>
          <Button
            className="xs:mx-24 md:w-1/4 mt-8"
            color="secondary"
            variant="contained"
            onClick={() =>
              place.interested.beacon
                ? setOpenThankYouDialog(true)
                : setOpenInterestingDialog(true)
            }
          >
            <FormattedMessage id="beacon.overview.getYourBeacon" />
          </Button>
          <BeaconOverviewDialogInteresting
            open={openInterestingDialog}
            setOpen={setOpenInterestingDialog}
            onSubmit={onLetMeKnow}
          ></BeaconOverviewDialogInteresting>
          <BeaconOverviewDialogThankYou
            open={openThankYouDialog}
            setOpen={setOpenThankYouDialog}
          ></BeaconOverviewDialogThankYou>
        </div>
      </div>
      <div className="flex flex-col px-20 items-center">
        <div className="max-w-md">
          <BeaconOverviewParagraph
            title={formatMessage({
              id: 'beacon.overview.whatAreBeacon.title',
            })}
            body={formatMessage({
              id: 'beacon.overview.whatAreBeacon.description',
            })}
          ></BeaconOverviewParagraph>

          <BeaconOverviewParagraph
            title={formatMessage({
              id: 'beacon.overview.whyShouldIUseBeacons.title',
            })}
            body={formatMessage({
              id: 'beacon.overview.whyShouldIUseBeacons.description',
            })}
          >
            <Typography variant="body1" className="mt-24">
              <FormattedMessage id="beacon.overview.whyShouldIuseBeacons.firstParagraph" />
            </Typography>
          </BeaconOverviewParagraph>

          <BeaconOverviewParagraph
            title={formatMessage(
              {
                id: 'beacon.overview.whyUseBeacons.title',
              },
              {
                appName,
              },
            )}
            body={formatMessage(
              {
                id: 'beacon.overview.whyUseBeacons.firstParagraph.description',
              },
              {
                appName,
              },
            )}
          >
            <div className="mt-24">
              <Typography variant="subtitle1" className="font-bold">
                <FormattedMessage
                  id="beacon.overview.whyUseBeacons.secondParagraph.title"
                  values={{ appName }}
                />
              </Typography>
              <Typography variant="body1">
                <FormattedMessage
                  id="beacon.overview.whyUseBeacons.secondParagraph.description"
                  values={{ appName }}
                />
              </Typography>
            </div>
            <div className="mt-24">
              <Typography variant="subtitle1" className="font-bold">
                <FormattedMessage
                  id="beacon.overview.whyUseBeacons.thirdParagraph.title"
                  values={{ appName }}
                />
              </Typography>
              <Typography variant="body1">
                <FormattedMessage
                  id="beacon.overview.whyUseBeacons.thirdParagraph.description"
                  values={{ appName }}
                />
              </Typography>
            </div>
          </BeaconOverviewParagraph>

          <BeaconOverviewParagraph
            title={formatMessage({
              id: 'beacon.overview.howDoesItWork.title',
            })}
            body={formatMessage(
              {
                id: 'beacon.overview.howDoesItWork.description',
              },
              {
                appName,
              },
            )}
          >
            <ol className="list-decimal py-16 font-bold italic">
              <li>
                <FormattedMessage id="beacon.overview.howDoesItWork.list.first" />
              </li>
              <li>
                <FormattedMessage id="beacon.overview.howDoesItWork.list.second" />
              </li>
              <li>
                <FormattedMessage id="beacon.overview.howDoesItWork.list.third" />
              </li>
              <li>
                <FormattedMessage id="beacon.overview.howDoesItWork.list.fourth" />
              </li>
              <li>
                <FormattedMessage
                  id="beacon.overview.howDoesItWork.list.fifth"
                  values={{ appName }}
                />
              </li>
              <li>
                <FormattedMessage id="beacon.overview.youAreAllSet" />
              </li>
            </ol>
          </BeaconOverviewParagraph>
          <Typography variant="body1" className="mt-16">
            <FormattedMessage
              id="beacon.overview.footer"
              values={{ appName }}
            />
            <Link
              to="#"
              onClick={onHelpCenter}
              className={clsx(classes.HelpLink, 'px-2')}
            >
              <FormattedMessage id="beacon.overview.footer.link" />
            </Link>
          </Typography>
        </div>
      </div>
    </div>
  )
}

const ContentToolbar = () => {
  return (
    <LargeToolbar
      content={
        <>
          <Typography variant="h6">
            <FormattedMessage id="beacon.title" />
          </Typography>
        </>
      }
    />
  )
}

export default () => {
  return (
    <ContentToolbarPage
      contentClassName="pb-24 px-0"
      contentToolbar={<ContentToolbar />}
      content={<Content />}
    />
  )
}
